import { _ as _root } from './_root.mjs';

var root = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

var _coreJsData = coreJsData;

export { _coreJsData as _ };
